import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import ReactSelectOption from '../../SelectOptions/ReactSelectOption';
import ApiService from '../../../Services/ApiService';
import AlertService from '../../../Services/AlertService';
import { DOCUMENT_TYPES, GENDERS } from '../../../Constants/MainKeys';
import MainService from '../../../Services/MainService';
import { ImSpinner3 } from 'react-icons/im';
import { useDispatch, useSelector } from 'react-redux';
import * as moment from "moment";
import FileUploadComponent from './FileUploadComponent';
import RedirectComponent from './RedirectComponent';
import { v4 as uuidv4 } from 'uuid';
import { setUserData, setUserToken } from '../../../Store/Reducers/userReducer';
import { BiLogOut } from 'react-icons/bi';

export default function UserVeriffForm({ countries, setIsShowLoader, setSessionId, sessionId }) {

  const { user } = useSelector(state => state.user);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isInvalidSubmit, setIsInvalidSubmit] = useState(false);
  const [verificationData, setVerificationData] = useState(false);
  const [stepNumber, setStepNumber] = useState(1);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [genders, setGenders] = useState([]);

  useEffect(() => {
    if (user) {
      setValues(prevValues => ({
        ...prevValues,
        person: {
          ...prevValues.person,
          firstName: user.firstname || "",
          lastName: user.lastname || "",
          idNumber: user.idNumber || "",
          gender: genders && genders.length && user.gender
            ? capitalizeFirstLetter(genders.find(el => el.key === user.gender)?.value || "")
            : "",
          dateOfBirth: user.dob ? moment(user.dob).format("YYYY-MM-DD") : "",
        },
        document: {
          ...prevValues.document,
          number: user.documentNumber || "",
          type: documentTypes && documentTypes.length && user.documentType
            ? documentTypes.find(el => el.key === user.documentType)?.value || ""
            : "",
          country: countries && countries.length && user.countryId
            ? countries.find(el => el.id === user.countryId)?.isoCode2 || ""
            : "",
        },
        address: {
          ...prevValues.address,
          fullAddress: user.addressResidence || "",
        }
      }));
    }
  }, [user, genders, documentTypes, countries]);

  useEffect(() => {
    getDocumentTypes()
    getGenders()
  }, [])

  const getDocumentTypes = () => {
    ApiService.getDocumentTypes().then(response => {
      if (response && response.data) {
        setDocumentTypes(response.data)
      }
    }).catch(error => AlertService.alert("error", error))
  }
  const getGenders = () => {
    ApiService.getGenders().then(response => {
      if (response && response.data) {
        setGenders(response.data)
      }
    }).catch(error => AlertService.alert("error", error))
  }

  const [values, setValues] = useState({
    person: {
      firstName: "",
      lastName: "",
      idNumber: "",
      gender: "",
      dateOfBirth: ""
    },
    document: {
      number: "",
      type: "",
      country: ""
    },
    address: {
      fullAddress: ""
    }
  });

  const handleChange = (section, field, value, maxLength = Infinity) => {
    if (value.length > maxLength) { return false; }
    setValues(prevValues => ({
      ...prevValues,
      [section]: {
        ...prevValues[section],
        [field]: value
      }
    }));
    setIsInvalidSubmit(false);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    const { person, document, address } = values;
    const allValues = { ...person, ...document, ...address };
    const hasEmptyField = Object.values(allValues).some(value => {
      return typeof value === 'string' && value.trim().length === 0;
    });

    if (hasEmptyField) {
      setIsInvalidSubmit(true);
      return;
    }
    setIsLoading(true);
    // gender 1 -male
    // gender 2 -female
    const valuesCopy = {
      firstName: values.person.firstName || "",
      lastName: values.person.lastName || "",
      addressResidence: values.address.fullAddress || "",
      gender: genders && genders.length ? genders.find(el => capitalizeFirstLetter(el.value) === values.person.gender)?.key : null,
      dob: values.person.dateOfBirth || "",
      countryId: countries && countries.length ? countries.find(el => el.isoCode2 === values.document?.country)?.id : null,
      documentType: documentTypes && documentTypes.length ? documentTypes.find(el => el.value === values.document.type)?.key : null,
      documentNumber: values.document.number,
      idNumber: values.person.idNumber,
    }
    ApiService.updatePaymentCustomerData(valuesCopy).then(() => {

      // const newUserData = { ...user };
      // newUserData.firstname = values.person.firstName || "";
      // newUserData.lastname = values.person.lastName || "";
      // newUserData.addressResidence = values.address.fullAddress || "";
      // newUserData.dob = values.person.dateOfBirth || "";
      // newUserData.country = countries.find(el => el.isoCode2 === values.document?.country)?.name;
      // dispatch(setUserData(newUserData));
      onStartVeriff();
    }).catch(error => { AlertService.alert("error", error); setIsLoading(false); })
  };

  const onStartVeriff = () => {
    ApiService.startVeriff({ requestId: uuidv4(), endUserId: user.id }).then(response => {
      if (response && response.data && response.data.data && response.data.data.verification) {
        setVerificationData(response.data.data.verification);
        const { verification } = response.data.data;
        setSessionId(verification?.id);
        setIsShowLoader(true);
        const url = verification?.url;
        window.open(url, "_blank");
        // window.location.replace(url)

        // setStepNumber(2);
      }
    })
      .catch(error => { AlertService.alert("error", error) })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const logout = () => {
    AlertService.alertConfirm(
      `Are you sure ?`,
      "",
      "Yes",
      "No"
    ).then(() => {
      dispatch(setUserData(null));
      dispatch(setUserToken(null));
    }).catch(() => { });
  }

  const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase();
  }

  return (
    <div>
      {
        (() => {
          switch (stepNumber) {
            case 1:
              return <Form onSubmit={onSubmit} className='py-2'>
                <Row>
                  <Col sm={12}>
                    <h5>Personal Information</h5>
                    <hr />
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mb-3" controlId="formFirstName">
                      <Form.Label>First Name*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="e.g. John"
                        required
                        className={`${isInvalidSubmit && !values.person.firstName.trim().length ? "error-border" : ""}`}
                        value={values.person.firstName}
                        onChange={(event) => handleChange('person', 'firstName', event.target.value, 120)}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mb-3" controlId="formLastName">
                      <Form.Label>Last Name*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="e.g. Smith"
                        required
                        className={`${isInvalidSubmit && !values.person.lastName.trim().length ? "error-border" : ""}`}
                        value={values.person.lastName}
                        onChange={(event) => handleChange('person', 'lastName', event.target.value, 120)}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mb-3" controlId="formDateOfBirth">
                      <Form.Label>Date of Birth*</Form.Label>
                      <Form.Control
                        type="date"
                        required
                        className={`${isInvalidSubmit && !values.person.dateOfBirth.trim().length ? "error-border" : ""}`}
                        max={MainService.getToday()}
                        value={values.person.dateOfBirth}
                        onChange={(event) => handleChange('person', 'dateOfBirth', event.target.value, 120)}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mb-3" controlId="formGender">
                      <Form.Label>Gender*</Form.Label>
                      {
                        genders && genders.length ?
                          <ReactSelectOption
                            value={values.person.gender}
                            isSearchable={true}
                            className={`veriff-modal-select-option ${isInvalidSubmit && !values.person.gender.trim().length ? "error-border" : ""}`}
                            selectedValue={(() => {
                              const selectedValue = genders.find(data => capitalizeFirstLetter(data.value) === values.person.gender);

                              return selectedValue ? { label: selectedValue.value, value: selectedValue.id } : null;
                            })()}
                            items={genders.map(data => ({ label: data.value, value: data.value }))}
                            onChange={(item) => {
                              handleChange('person', 'gender', capitalizeFirstLetter(item.value))
                            }}
                          />
                          : null
                      }
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mb-3" controlId="formIdNumber">
                      <Form.Label>ID Number*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="e.g. 123456789"
                        required
                        className={`${isInvalidSubmit && !values.person.idNumber.trim().length ? "error-border" : ""}`}
                        value={values.person.idNumber}
                        onChange={(event) => handleChange('person', 'idNumber', event.target.value, 120)}
                      />
                    </Form.Group>
                  </Col>

                </Row>
                <Row className="mt-2">
                  <Col sm={12}>
                    <h5>Document</h5>
                    <hr />
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mb-3" controlId="formCountry">
                      <Form.Label>Country*</Form.Label>
                      <ReactSelectOption
                        value={values.document.country}
                        className={`veriff-modal-select-option ${isInvalidSubmit && !values.document.country.trim().length ? "error-border" : ""}`}
                        isSearchable={true}
                        selectedValue={(() => {
                          const selectedValue = countries.find(data => data.isoCode2 === values.document.country);
                          return selectedValue ? { label: selectedValue.name, value: selectedValue.id } : null;
                        })()}
                        items={countries.map(data => ({ label: data.name, value: data.id, isoCode2: data.isoCode2 }))}
                        onChange={(item) => handleChange('document', 'country', item.isoCode2)}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mb-3" controlId="formDocumentType">
                      <Form.Label>Document Type*</Form.Label>
                      {
                        documentTypes && documentTypes.length ?
                          <ReactSelectOption
                            value={values.document.type}
                            className={`veriff-modal-select-option ${isInvalidSubmit && !values.document.type.trim().length ? "error-border" : ""}`}
                            isSearchable={true}
                            selectedValue={(() => {
                              const selectedValue = documentTypes.find(data => data.value === values.document.type);
                              return selectedValue ? { label: MainService.formatString(selectedValue.value), value: selectedValue.value } : null;
                            })()}
                            items={documentTypes.map(data => ({ label: MainService.formatString(data.value), value: data.value }))}
                            onChange={(item) => handleChange('document', 'type', item.value)}
                          />
                          : null
                      }
                    </Form.Group>
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mb-3" controlId="formDocumentNumber">
                      <Form.Label>Document Number*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="e.g. 123456789"
                        required
                        className={`${isInvalidSubmit && !values.document.number.trim().length ? "error-border" : ""}`}
                        value={values.document.number}
                        onChange={(event) => handleChange('document', 'number', event.target.value, 120)}
                      />
                    </Form.Group>
                  </Col>


                </Row>
                <Row className="mt-2">
                  <Col sm={12}>
                    <h5>Address</h5>
                    <hr />
                  </Col>
                  <Col sm={12}>
                    <Form.Group className="mb-3" controlId="formFullAddress">
                      <Form.Label>Full Address*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="e.g. John Doe, 456 Elm Street, Suite 3, Los Angeles, CA 90001, USA."
                        required
                        className={`${isInvalidSubmit && !values.address.fullAddress.trim().length ? "error-border" : ""}`}
                        value={values.address.fullAddress}
                        onChange={(event) => handleChange('address', 'fullAddress', event.target.value, 1000)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col sm={12} className="d-flex justify-content-end gap-2">
                    <Button
                      variant='danger'
                      className="d-flex gap-2 align-items-center"
                      onClick={logout}
                    >
                      <BiLogOut />
                      Logout
                    </Button>
                    {
                      isLoading ?
                        <Button type='submit' variant="primary" className='px-4' disabled>
                          <span className='me-2'> Loading</span>
                          <ImSpinner3 className='rotating' />
                        </Button>
                        : <Button variant="primary" type="submit"> Submit & Continue</Button>
                    }
                  </Col>
                </Row>
              </Form>
            case 2:
              return <RedirectComponent verificationData={verificationData} setStepNumber={setStepNumber} setIsShowLoader={setIsShowLoader} />
            case 3:
              return <FileUploadComponent setIsShowLoader={setIsShowLoader} setStepNumber={setStepNumber} sessionId={sessionId} />
            default:
              break;
          }
        })()
      }

    </div>
  );
}


// John Doe, 456 Elm Street, Suite 3, Los Angeles, CA 90001, USA.